var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ie11hack"},[_c('div',{staticClass:"modal-header"},[(_vm.hasImage)?_c('img',{ref:"ie11image",staticClass:"logo",attrs:{"src":_vm.imagePath,"alt":"","aria-hidden":"true"}}):_vm._e(),_c('h2',{staticClass:"h4 modal-title"},[_vm._t("headline")],2)]),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }